// screen: Entry redirect
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth } from '~/app/auth';
import { Skeleton } from '@viewstream/ui';

export const Route = createFileRoute('/')({ component: Entry });

function Entry() {
  const { me, loading } = useAuth();
  if (loading) return <div className="p-8"><Skeleton className="h-8 w-48" /></div>;
  if (!me?.user) return <Navigate to="/login" search={{ next: undefined }} />;
  if (__APP__ === 'admin') return me.user.interhost_role ? <Navigate to={'/admin/tenants' as never} /> : <Navigate to="/login" search={{ next: undefined }} />;
  const slug = me.current_tenant?.slug ?? me.tenants[0]?.slug;
  if (!slug) return <Navigate to="/login" search={{ next: undefined }} />;
  return <Navigate to="/t/$slug" params={{ slug }} />;
}
